"use client";

// Consent-withdrawal control — the privacy page's "cookie
// settings" link. Clears the stored choice so CookieConsent reappears on the next render,
// letting a visitor who accepted revisit that decision.

import { clearConsent } from "@/lib/consent";

export function CookieSettingsButton() {
  return (
    <button
      type="button"
      onClick={() => clearConsent()}
      className="text-primary underline underline-offset-2 hover:text-primary-hover"
    >
      cookie settings
    </button>
  );
}
